export default __webpack_public_path__ + "static/media/myplanIcon.ed0066f8.svg";